import { createActions, createReducer } from 'reduxsauce'

const competencias = [
    { value: '01', label: 'Janeiro' },
    { value: '02', label: 'Fevereiro' },
    { value: '03', label: 'Março' },
    { value: '04', label: 'Abril' },
    { value: '05', label: 'Maio' },
    { value: '06', label: 'Junho' },
    { value: '07', label: 'Julho' },
    { value: '08', label: 'Agosto' },
    { value: '09', label: 'Setembro' },
    { value: '10', label: 'Outubro' },
    { value: '11', label: 'Novembro' },
    { value: '12', label: 'Dezembro' },
]

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioDespesasMensais: ['exercicio'],
    setCompetenciaDespesasMensais: ['competencia'],
    setAdministracaoDespesasMensais: ['administracao'],
    setPredioDespesasMensais: ['predio'],
    setUnidadeDespesasMensais: ['unidade'],
    setTipoServicoDespesasMensais: ['tipoServico'],
    setCnpjDespesasMensais: ['cnpj'],
    setIdentificadorDespesasMensais: ['identificador'],
    setNomeFornecedorDespesasMensais: ['nomeFornecedor'],
    limpaFiltroDespesasMensais: [],
    receberFiltroDespesasMensais: ['filtroRecebido'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    competencia: { value: null, label: 'Todos' },
    administracao: [],
    predio: [],
    unidade: [],
    tipoServico: [],
    cnpj: '',
    identificador: '',
    nomeFornecedor: '',
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setCompetencia = (state = INITIAL_STATE, action) => {
    return { ...state, competencia: action.competencia }
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setPredio = (state = INITIAL_STATE, action) => {
    return { ...state, predio: action.predio }
}

const setUnidade = (state = INITIAL_STATE, action) => {
    return { ...state, unidade: action.unidade }
}

const setTipoServico = (state = INITIAL_STATE, action) => {
    return { ...state, tipoServico: action.tipoServico }
}

const setCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: action.cnpj }
}

const setIdentificador = (state = INITIAL_STATE, action) => {
    return { ...state, identificador: action.identificador }
}

const setNomeFornecedor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeFornecedor: action.nomeFornecedor }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_DESPESAS_MENSAIS]: setExercicio,
    [Types.SET_COMPETENCIA_DESPESAS_MENSAIS]: setCompetencia,
    [Types.SET_ADMINISTRACAO_DESPESAS_MENSAIS]: setAdministracao,
    [Types.SET_PREDIO_DESPESAS_MENSAIS]: setPredio,
    [Types.SET_UNIDADE_DESPESAS_MENSAIS]: setUnidade,
    [Types.SET_TIPO_SERVICO_DESPESAS_MENSAIS]: setTipoServico,
    [Types.SET_CNPJ_DESPESAS_MENSAIS]: setCnpj,
    [Types.SET_IDENTIFICADOR_DESPESAS_MENSAIS]: setIdentificador,
    [Types.SET_NOME_FORNECEDOR_DESPESAS_MENSAIS]: setNomeFornecedor,
    [Types.LIMPA_FILTRO_DESPESAS_MENSAIS]: limpaFiltro,
    [Types.RECEBER_FILTRO_DESPESAS_MENSAIS]: receberFiltro,
})
